<template>
  <base-message :message="message">
    <div v-show="!loading"
         class="message-body image-message">
      <img v-show="message.status !== 'error'"
           :id="'image-' + _uid"
           :src="message.data.src">
      <span v-show="message.status === 'error'">图片加载失败……</span>
    </div>
    <loading-dot v-show="loading"></loading-dot>
  </base-message>
</template>

<script>
  import LoadingDot from './LoadingDot'
  import BaseMessage from './BaseMessage'
  import IClassroom from '../lib/IClassroom'

  export default {
    components: {LoadingDot, BaseMessage},
    props: ['message'],
    data () {
      return {
        loading: true
      }
    },
    mounted () {
      const id = this._uid
      const app = this
      let image = document.getElementById('image-' + id)

      function done () {
        app.loading = false
        image.removeEventListener('load', loaded)
        image.removeEventListener('error', error)
      }

      function loaded () {
        IClassroom.focusToMessage(app.message)
        done()
      }

      function error () {
        app.message.status = 'error'
        done()
      }

      if (image.complete) {
        loaded()
      } else {
        image.addEventListener('load', loaded)
        image.addEventListener('error', error)
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .image-message {
    width 100%
    height 100%
  }

  .is-danger .image-message {
    padding .5em .75em
  }
</style>
